import Footer from '../../components/footer';
import TopNav from '../../components/top-nav';
import { usePageTitle } from '../../utils/page-title';
import style from '../privacy-policy/style.module.scss';

export default function The404Page() {
  // Note: don't change this title w/out also updating index.tsx since document.title
  // is how we identify the 404 page to avoid hydration on dynamic routes
  usePageTitle('404 Not Found');
  return (
    <>
      <TopNav isTransparent={false} />
      <div class={style.wrapper}>
        <h1>404 Not Found</h1>
        <div style={{ height: `30vh` }}></div>
      </div>
      <Footer />
    </>
  );
}
